import { cn } from "@peerigon/pupper/tailwind";
import type { CSSProperties } from "react";

type GoToBlogArticleWrapperProps = {
	color: string;
	className?: string;
	children?: React.ReactNode;
};

export const GoToBlogArticleWrapper = ({
	color,
	className,
	children,
}: GoToBlogArticleWrapperProps) => (
	<div
		className={cn(
			"flex items-center justify-end m-[15px]",
			"md:mt-[-20px]",
			"lg:justify-self-end lg:justify-start lg:m-px-30 lg:mt-0",
			className,
		)}
		style={{ color } as CSSProperties}
	>
		{children}
	</div>
);
